import Repository from './repository'

const resource = '/zipcodes'

export default {
  getAddress (zipcode) {
    return Repository.get(`${resource}/address`, {params: {zipcode}})
  }
}



// WEBPACK FOOTER //
// ./src/repositories/zipcodesRepository.js